import type { SiteLang } from "@/hooks/useLanguage";

export const CONTENT_TYPES = [
  { key: "blog_posts", label: "Blog", route: "/en/blog", color: "#3F6C8A" },
  { key: "regulatory_updates", label: "Regulatory Update", route: "/en/regulatory-updates", color: "#6B8FA3" },
  { key: "webinars", label: "Webinar", route: "/en/webinars", color: "#57B0BD" },
  { key: "white_papers", label: "White Paper", route: "/en/downloads", color: "#8B6BAE" },
  { key: "checklists", label: "Checklist", route: "/en/downloads/checklists", color: "#3D8F7A" },
  { key: "case_studies", label: "Case Study", route: "/en/case-studies", color: "#4A7C6F" },
  { key: "podcasts", label: "Podcast", route: "/en/podcasts", color: "#E05A47", excludeFromKnowledgeCenter: true },
  { key: "company_news", label: "Company News", route: "/en/news", color: "#A68B3C", excludeFromKnowledgeCenter: true },
  { key: "events", label: "Event", route: "/en/events", color: "#C4784A", excludeFromKnowledgeCenter: true },
  
] as const;

const contentTypeLabelI18n: Record<string, Record<SiteLang, string>> = {
  blog_posts: { en: "Blog", es: "Blog", "zh-cn": "博客" },
  regulatory_updates: { en: "Regulatory Update", es: "Actualización regulatoria", "zh-cn": "法规动态" },
  webinars: { en: "Webinar", es: "Webinar", "zh-cn": "网络研讨会" },
  white_papers: { en: "White Paper", es: "White Paper", "zh-cn": "白皮书" },
  checklists: { en: "Checklist", es: "Checklist", "zh-cn": "检查清单" },
  case_studies: { en: "Case Study", es: "Caso de éxito", "zh-cn": "成功案例" },
  podcasts: { en: "Podcast", es: "Podcast", "zh-cn": "播客" },
  company_news: { en: "Company News", es: "Noticias", "zh-cn": "新闻" },
  events: { en: "Event", es: "Evento", "zh-cn": "活动" },
};

export const getContentTypeLabel = (key: string, lang: SiteLang): string =>
  contentTypeLabelI18n[key]?.[lang] ?? contentTypeLabelI18n[key]?.en ?? key;

export const KNOWLEDGE_CENTER_TYPES = CONTENT_TYPES.filter((t) => !("excludeFromKnowledgeCenter" in t && t.excludeFromKnowledgeCenter));

/** Tags/categories to hide from all public-facing content listings and filters */
export const EXCLUDED_TAGS: string[] = ["latam-only", "_hidden"];

/** Categories to hide from filter UI but still show their content in listings */
export const EXCLUDED_FILTER_CATEGORIES: string[] = ["General", "Business", "Communications", "Business & Communications", "Life Sciences"];

export type ContentTypeKey = (typeof CONTENT_TYPES)[number]["key"];

export interface UnifiedResource {
  id: string;
  slug: string;
  title: string;
  summary?: string | null;
  featured_image?: string | null;
  category?: string | null;
  industry_category?: string | null;
  service_category?: string | null;
  published_at?: string | null;
  author?: string | null;
  tags?: string[] | null;
  content?: string | null;
  contentType: ContentTypeKey;
  webinar_date?: string | null;
  recording_url?: string | null;
  parent_slug?: string | null;
  video_url?: string | null;
  episode_number?: number | null;
}

export const getContentTypeMeta = (key: ContentTypeKey) =>
  CONTENT_TYPES.find((t) => t.key === key)!;
